/**
 * zIndex
 * @param values
 */
export function zIndex(name) {
    return function (_a) {
        var theme = _a.theme;
        return theme.zIndex[name];
    };
}
